module.exports = __webpack_public_path__ + "img/food-information_even.b4c4e0fb.svg";